var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStatisticsEmail = function SvgStatisticsEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_15765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5511 12.9961L13.541 15.0129C12.7259 15.8309 11.2917 15.8485 10.459 15.0129L8.44885 12.9961L1.22935 20.239C1.49808 20.3633 1.79438 20.4375 2.10938 20.4375H21.8906C22.2056 20.4375 22.5018 20.3634 22.7705 20.2391L15.5511 12.9961Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 3.5625H2.10938C1.79438 3.5625 1.49808 3.63666 1.22944 3.76092L8.94399 11.5011C8.9445 11.5016 8.94511 11.5017 8.94563 11.5022C8.94614 11.5027 8.94624 11.5034 8.94624 11.5034L11.4547 14.0201C11.7211 14.2866 12.279 14.2866 12.5454 14.0201L15.0533 11.5038C15.0533 11.5038 15.054 11.5027 15.0545 11.5022C15.0545 11.5022 15.0556 11.5016 15.0561 11.5011L22.7705 3.76088C22.5018 3.63656 22.2056 3.5625 21.8906 3.5625Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.224344 4.74414C0.0853125 5.0253 0 5.33739 0 5.6717V18.328C0 18.6623 0.0852187 18.9744 0.224297 19.2555L7.45631 12.0001L0.224344 4.74414Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7757 4.74414L16.5437 12.0002L23.7757 19.2557C23.9147 18.9745 24 18.6625 24 18.328V5.6718C24 5.33739 23.9147 5.0253 23.7757 4.74414Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_15765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStatisticsEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/statistics-email.54f5ce47614244901dbdc1a0d335951a.svg";